import * as React from 'react';

const SvgComponent = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <rect width={15} height={15} x={0.5} y={0.5} fill="#fff" stroke="#DADBDD" rx={1.5} />
  </svg>
);
export default SvgComponent;
